import React, {memo} from 'react';
import {OptionalInvoiceExportFieldStates} from './InvoicePDFTypes';
import {Document, Font, Page} from '@react-pdf/renderer';
import {InvoicePDFDownloadModal_viewer} from './__generated__/InvoicePDFDownloadModal_viewer.graphql';
import {IntlShape} from 'react-intl';
import InvoicePDFHeader from './InvoicePDFHeader';
import InvoicePDFTable from './InvoicePDFTable';
import InvoicePDFFooter from './InvoicePDFFooter';

type InvoicePDFProps = {
	invoiceData: InvoicePDFDownloadModal_viewer['invoice'];
	companyData: InvoicePDFDownloadModal_viewer['company'];
	optionalFields: OptionalInvoiceExportFieldStates;
	intl: IntlShape;
};

// Done to avoid words being hyphenated in the PDF
Font.registerHyphenationCallback(word => [word]);

const InvoicePDF = memo(({invoiceData, companyData, optionalFields, intl}: InvoicePDFProps): JSX.Element => {
	return (
		<Document>
			<Page size="A4" style={[{paddingVertical: '32px', paddingHorizontal: '41px'}]}>
				<InvoicePDFHeader
					invoiceData={invoiceData}
					companyData={companyData}
					intl={intl}
					optionalFields={optionalFields}
				/>
				<InvoicePDFTable invoiceData={invoiceData} intl={intl} />
				{optionalFields.invoiceNotesChecked && <InvoicePDFFooter invoiceData={invoiceData} intl={intl} />}
			</Page>
		</Document>
	);
});

export default InvoicePDF;
